module.exports = __webpack_public_path__ + "static/tooltip1_5-c697bd6f785c8123df0f7ca20bf91d0f.png";